import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PAGES = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/refund-policy', label: 'Refund Policy' },
];

export default function LegalHero({ kicker, title, updated, image, accent = '#c4151c' }) {
  const { pathname } = useLocation();

  return (
    <div className="mb-10">
      <div className="flex flex-col sm:flex-row items-center sm:items-end gap-5 sm:gap-8 text-center sm:text-left">
        <img
          src={image}
          alt=""
          className="w-36 h-36 sm:w-44 sm:h-44 rounded-[1.75rem] object-cover shrink-0 shadow-xl ring-4 ring-white bg-[#fbf7f2]"
        />
        <div className="min-w-0">
          <span
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4"
            style={{ backgroundColor: `${accent}14`, color: accent }}
          >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent }} />
            {kicker}
          </span>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-gray-900 mb-3">
            {title}
          </h1>
          <p className="text-sm text-gray-500 font-medium">{updated}</p>
        </div>
      </div>
      <nav className="mt-6 flex flex-wrap justify-center sm:justify-start gap-2" aria-label="Legal pages">
        {PAGES.map((p) => {
          const current = pathname === p.to;
          return (
            <Link
              key={p.to}
              to={p.to}
              className={`px-3.5 py-1.5 rounded-full text-xs font-black uppercase tracking-widest border transition-colors ${
                current
                  ? 'text-white border-transparent'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300 hover:text-gray-900'
              }`}
              style={current ? { backgroundColor: accent } : undefined}
            >
              {p.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
